<ion-header>
	<ion-toolbar class="default-toolbar edge-to-edge-top" [class.!tw-py-0]="!isMobile()">
		<ion-buttons slot="start">
			<ion-button ion-button clear (click)="close()">
				<ion-icon src="assets/icon/Close.svg"></ion-icon>
			</ion-button>
		</ion-buttons>

		<ion-title>
			<span>{{ "texts.terms_of_use" | translate }}</span>
		</ion-title>
	</ion-toolbar>
</ion-header>

<div class="background terms">
	<p [innerHTML]="terms | safeHtml" *ngIf="terms !== null && terms !== undefined"></p>
</div>
